module.exports = __webpack_public_path__ + "static/assets/430f222c31bfe049d8e33061ba2dd8c2.png";